import * as React from 'react';
import { Button } from '@naan/primitives/button';
import { styled } from '@naan/stitches.config';
import { ArrowDownExtraSmallIcon } from '@naan/icons/arrow-down-icon';
import { scrollTo } from 'soundbite/fx/scrolling';
import { ANSWER_CARD_ID } from './answer';
import { useReaction } from '@common/hooks/use-reaction';
import { soundbitePlayerUiModel } from 'soundbite/fx/soundbite-player-ui-model';
import { toggleClassname } from '@utils/toggle-class';
import { AppFactory } from '@app/app-factory';
import { AnswerState } from 'soundbite/models/soundbite-model';
import __ from '@core/lib/localization';

const Wrapper = styled('div', {
  position: 'fixed',
  bottom: 0,
  left: 0,
  // background: 'red',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  paddingBottom: 'calc(16px + var(--sab) )',
  '& > .inner': {
    transition: 'transform 0.3s ease-in-out',
    transform: 'translate(0, -80px)', // height of SB player controls
  },
  '&.hidden': {
    '& > .inner': {
      transform: 'translate(0, 0)',
    },
  },
  // zIndex: 100,
});

function answerElement() {
  return document.getElementById(ANSWER_CARD_ID);
}

function scrollToAnswer() {
  requestAnimationFrame(() => {
    scrollTo(answerElement());
  });
}

export const ScrollToAnswerButton = React.memo(() => {
  const { answerState: state } = AppFactory.soundbiteModel;

  const ref = React.useRef();
  useReaction(
    () => soundbitePlayerUiModel.showScrollToAnswerButton,
    show => {
      if (ref.current) {
        toggleClassname(ref.current, 'hidden', show === false);
      }
    }
  );

  if (state !== AnswerState.revealed) {
    return null;
  }

  return (
    <Wrapper ref={ref}>
      <div className="inner">
        <Button
          presentation="green"
          label={__('Scroll to answer', 'scrollToAnswer')}
          leftIcon={<ArrowDownExtraSmallIcon />}
          onClick={() => {
            scrollToAnswer();
          }}
        />
      </div>
    </Wrapper>
  );
});
